import React, { useState, useEffect } from "react";
import MostrarCotizacion from "./MostrarCotizacion";
import { Button, Card, Col, Row, Form, Container } from "react-bootstrap";
import API from "../api"; // ✅ Importa la URL base
import "./Cotizacion.css";


function Cotizacion() {
  const [contador, setContador] = useState(1);
  const [cotizacionGuardada, setCotizacionGuardada] = useState(null);
  const [productos, setProductos] = useState([
    "Arriendo Maquinaria",
    "Venta aridos",
    "Retiro de escombros",
    "Limpieza de terreno",
    "Movimiento de tierra",
  ]);
  const [datos, setDatos] = useState({
    numero: 0,
    cliente: "",
    producto: "",
    dias: 0,
    horas: 0,
    precioUnitario: 0,
    descripcion: "",
    nota: "",
  });

  // Función para formatear números con separador de miles
  const formatearNumero = (numero) => {
    return new Intl.NumberFormat("es-CL").format(numero);
  };

  // Función para eliminar el formato al guardar el número
  const desformatearNumero = (numeroFormateado) => {
    return numeroFormateado.replace(/\./g, "");
  };

  useEffect(() => {
    const obtenerNumero = async () => {
      try {
        const res = await fetch(`${API}/cotizaciones/ultimo`);
        const data = await res.json();
        const nuevoNumero = data.numero ? data.numero + 1 : 1;
        setContador(nuevoNumero);
        setDatos((prev) => ({ ...prev, numero: nuevoNumero }));
      } catch (error) {
        console.error("Error al obtener número:", error);
      }
    };

    obtenerNumero();
  }, []);

  const handleChange = (campo, valor) => {
    if (campo === "precioUnitario" || campo === "dias" || campo === "horas") {
      valor = desformatearNumero(valor);
    }
    setDatos((prev) => ({ ...prev, [campo]: valor }));
  };

  const handleGuardar = async () => {
    if (!datos.cliente || !datos.producto || datos.dias <= 0 || datos.horas <= 0 || datos.precioUnitario <= 0) {
      alert("⚠️ Todos los campos deben estar completos.");
      return;
    }

    // Convertir precio unitario y horas a número antes de cálculos
    const valorNeto = datos.precioUnitario * datos.horas;
    const iva = valorNeto * 0.19;
    const valorTotal = valorNeto + iva;

    const cotizacionFinal = {
      ...datos,
      numero: contador,
      valorNeto,
      iva,
      valorTotal,
      fecha: new Date(),
    };

    try {
      const res = await fetch(`${API}/cotizaciones`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cotizacionFinal),
      });

      if (res.ok) {
        alert(`✅ Cotización N°${contador} guardada con éxito`);
        setCotizacionGuardada(cotizacionFinal);
        const nuevoNumero = contador + 1;
        setContador(nuevoNumero);
        setDatos((prev) => ({ ...prev, numero: nuevoNumero }));
      } else {
        alert("❌ Error al guardar cotización");
      }
    } catch (error) {
      alert("❌ Error: " + error.message);
    }
  };

  return (
    <Container className="form-container">
  <div className="header-container">
    <img src="/movimonte-logo.png" alt="Logo Empresa" />
    <div className="header-text">
      <h1>MOVIMENTOMONTE SPA</h1>
      <h3>Presupuesto N°{contador}</h3>
    </div>
  </div>


      <Row className="g-4">
        {/* Cliente */}
        <Col md={6}>
          <Card>
            <Card.Body>
              <Form.Group controlId="cliente">
                <Form.Label>Cliente</Form.Label>
                <Form.Control
                  type="text"
                  value={datos.cliente}
                  onChange={(e) => handleChange("cliente", e.target.value)}
                  placeholder="Ingrese el nombre del cliente"
                />
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>

        {/* Producto */}
        <Col md={6}>
          <Card>
            <Card.Body>
              <Form.Group controlId="producto">
                <Form.Label>Producto</Form.Label>
                <Form.Control
                  type="text"
                  value={datos.producto}
                  onChange={(e) => handleChange("producto", e.target.value)}
                  placeholder="Escribe un producto o selecciona uno"
                />
                <div className="mt-3">
                  <select
                    value={datos.producto}
                    onChange={(e) => handleChange("producto", e.target.value)}
                    className="form-select"
                  >
                    <option value="">Seleccione un producto</option>
                    {productos.map((producto, index) => (
                      <option key={index} value={producto}>
                        {producto}
                      </option>
                    ))}
                  </select>
                </div>
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>

        {/* Días */}
        <Col md={6}>
          <Card>
            <Card.Body>
              <Form.Group controlId="dias">
                <Form.Label>Días</Form.Label>
                <Form.Control
                  type="number"
                  value={formatearNumero(datos.dias)}
                  onChange={(e) => handleChange("dias", e.target.value)}
                  placeholder="Número de días"
                />
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>

        {/* Horas */}
        <Col md={6}>
          <Card>
            <Card.Body>
              <Form.Group controlId="horas">
                <Form.Label>Horas</Form.Label>
                <Form.Control
                  type="number"
                  value={formatearNumero(datos.horas)}
                  onChange={(e) => handleChange("horas", e.target.value)}
                  placeholder="Número de horas"
                />
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>

        {/* Precio Unitario */}
        <Col md={6}>
          <Card>
            <Card.Body>
              <Form.Group controlId="precioUnitario">
                <Form.Label>Precio Unitario</Form.Label>
                <Form.Control
                  type="number"
                  value={formatearNumero(datos.precioUnitario)}
                  onChange={(e) => handleChange("precioUnitario", e.target.value)}
                  placeholder="Precio unitario"
                />
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>

        {/* Descripción */}
        <Col md={12}>
          <Card>
            <Card.Body>
              <Form.Group controlId="descripcion">
                <Form.Label>Descripción</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={datos.descripcion}
                  onChange={(e) => handleChange("descripcion", e.target.value)}
                  placeholder="Descripción del servicio"
                />
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>

        {/* Nota */}
        <Col md={12}>
          <Card>
            <Card.Body>
              <Form.Group controlId="nota">
                <Form.Label>Nota</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={datos.nota}
                  onChange={(e) => handleChange("nota", e.target.value)}
                  placeholder="Nota adicional"
                />
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div style={buttonContainerStyle}>
        <Button variant="primary" onClick={handleGuardar}>
          Guardar Cotización
        </Button>
      </div>

      {cotizacionGuardada && (
        <div style={{ marginTop: 40 }}>
          <MostrarCotizacion datos={cotizacionGuardada} />
        </div>
      )}
    </Container>
  );
}

const formContainerStyle = {
  padding: "30px",
  maxWidth: "800px",
  margin: "0 auto",
};

const headerContainerStyle = {
  display: "flex",
  alignItems: "center",
  marginBottom: "20px",
};

const logoStyle = {
  width: "80px",
  marginRight: "20px",
};

const headerStyle = {
  fontSize: "30px",
  fontWeight: "bold",
  margin: "0",
};

const subHeaderStyle = {
  fontSize: "18px",
  fontWeight: "300",
};

const buttonContainerStyle = {
  textAlign: "center",
  marginTop: "20px",
};

export default Cotizacion;
